import { useState, useEffect } from "react";
import HomePage from "./pages/Home";
import MeetPage from "./pages/Meet";
import ClassesPage from "./pages/Classes";
import GalleryPage from "./pages/Gallery";
import ReviewsPage from "./pages/Reviews";
import PartiesPage from "./pages/Parties";
import SchoolsPage from "./pages/Schools";
import ContactPage from "./pages/Contact";
import MerchPage from "./pages/Merch";
import AdminPage from "./pages/Admin";
import BookingSuccess from "./pages/BookingSuccess";

export default function App() {
  const [page, setPage] = useState("home");

  const navigate = (id) => {
    setPage(id);
    window.scrollTo(0, 0);
    window.location.hash = id;
  };

  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) setPage(hash);
    const onHash = () => {
      const h = window.location.hash.replace("#", "");
      if (h) { setPage(h); window.scrollTo(0, 0); }
    };
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  switch (page) {
    case "home": return <HomePage setPage={navigate} />;
    case "meet": return <MeetPage setPage={navigate} />;
    case "classes": return <ClassesPage setPage={navigate} />;
    case "gallery": return <GalleryPage setPage={navigate} />;
    case "reviews": return <ReviewsPage setPage={navigate} />;
    case "parties": return <PartiesPage setPage={navigate} />;
    case "schools": return <SchoolsPage setPage={navigate} />;
    case "merch": return <MerchPage setPage={navigate} />;
    case "contact": return <ContactPage setPage={navigate} />;
    case "admin": return <AdminPage setPage={navigate} />;
    case "booking-success": return <BookingSuccess />;
    default: return <HomePage setPage={navigate} />;
  }
}
